module.exports = __webpack_public_path__ + "img/class-lazy.28dd9924.png";